import React from "react";

import { useModalContext } from "../../contexts/ModalContext/context";
import { IIntegrationsMappings } from "../../services/IntegrationApi";
import { Button } from "../../UI/Button";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { IntegrationDeleteModal } from "./IntegrationDeleteModal";

export const IntegrationDeleteButton: React.FC<IIntegrationsMappings> = (props) => {
  const { setIsOpen } = useModalContext();

  const openModal = () => setIsOpen(true);

  return (
    <>
      <ReadOnlyWrapper>
        <Button appearance="danger" onClick={openModal}>
          Delete
        </Button>
      </ReadOnlyWrapper>
      <IntegrationDeleteModal id={props.id} />
    </>
  );
};
